import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  faTrashAlt as fasTrash,
  faExclamationCircle,
  faExclamationTriangle,
  faCheck,
  faSave as fasSave,
  faBell as fasBell,
  faArrowAltFromBottom as fasArrowAltFromBottom,
  faShare as fasShare,
  faSpinner,
  faFileExcel as fasExcel,
} from "@fortawesome/pro-solid-svg-icons";
import {
  faPencilAlt as falPencil,
  faTrashAlt as falTrash,
  faBell as falBell,
  faArrowAltFromBottom as falArrowAltFromBottom,
  faShare as falShare,
  faSave as falSave,
  faFileExcel as falExcel,
} from "@fortawesome/pro-light-svg-icons";
import { WatchlistRowObject } from "../watchlist-page.model";
import { CommonModalService } from "../../shared/common-modal/common-modal.service";
import { WatchlistPageService } from "../watchlist-page.service";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/state/app.state";
import {
  DeleteWatchlistData,
  UpdateWatchlistData,
} from "src/app/store/actions/global.actions";
import { WatchlistGridComponent } from "../watchlist-grid/watchlist-grid.component";
import { WatchlistSearchAddComponent } from "src/app/watchlist/watchlist-search-add/watchlist-search-add.component";
import { Dictionary } from "src/app/store/models/common_types";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { AppService } from "src/app/app.service";
import { NzModalRef } from "ng-zorro-antd/modal";

@Component({
  selector: "app-watchlist-page",
  templateUrl: "./watchlist-page.component.html",
  styleUrls: ["./watchlist-page.component.scss"],
  host: { class: "watchlist-page-component" },
})
export class WatchlistPageComponent implements OnInit {
  falTrash = falTrash;
  fasTrash = fasTrash;
  falPencil = falPencil;
  fasSave = fasSave;
  falSave = falSave;
  fasBell = fasBell;
  falBell = falBell;
  fasShare = fasShare;
  falShare = falShare;
  faSpinner = faSpinner;
  fasArrowAltFromBottom = fasArrowAltFromBottom;
  falArrowAltFromBottom = falArrowAltFromBottom;
  faExclamationTriangle = faExclamationTriangle;
  falExcel = falExcel;
  fasExcel = fasExcel;

  hasUserCreatedWatchlists: boolean = null;
  isVisibleWatchlistModal = false;
  showGridFilter = false;

  //inititalize to -1.
  //when set to -1 deletion and rename functionality on a watchlist is not allowed
  watchlistId = -1;
  isVisibleSearchAndAddWatchlistModal = false;
  isVisibleSaveWatchlistModal = false;
  isVisibleReuploadModal = false;
  isVisibleShareWLModal = false;
  tickersList: any;
  inEditMode = false;
  watchlistName = "";
  watchlistInitialName = "";
  watchlistError = "";
  isOwned = false;
  visibleAlerts = false;
  alertsParams: Dictionary<any>;
  @ViewChild(WatchlistGridComponent)
  gridData: WatchlistGridComponent;
  @ViewChild(WatchlistSearchAddComponent)
  updatedTickers: WatchlistSearchAddComponent;
  watchlistGridData: WatchlistRowObject[];
  lastTransactionInfo: any;
  isGridLoading: boolean;
  isWatchlistExist = true;
  finalizedTickers: any = [];
  disableUpdateButton: boolean;
  isShowWarningModalVisible = false;
  reUploadModalTitle = "Re-upload a Watchlist File";
  selectedTickersCount = 0;
  selectedGridTickers: string[];
  loadingState = false;
  deleteEntireWatchlist = false;
  tooltipVisible = true;
  isExcelLoading = false;
  constructor(
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private modalService: CommonModalService,
    private watcherService: WatchlistPageService,
    private appService: AppService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.tickersList = [];
    this.route.params.subscribe((param) => {
      this.isGridLoading = true;
      if (!param.watchlistId) {
        this.watcherService
          .getLatestWatchlistId()
          .subscribe((response: any) => {
            if (response.data && response.data.id) {
              // redirect the page with this.watchlistId, so that it is updated in url
              // can't keep /watchlist alon in url, because when a watchlist is deleted, I want to be able to
              // open first watchlist, to do it, I either need to call some api to get updated list of watchlists
              // or I can send user to /watchlist and he automatically reaches to first one
              // Now if user is already on /watchlist, then sending again to /watchlist will not change anything on page
              // that's why I'm moving the user to /watchlist/:id url so that case can be easily handled
              this.router.navigateByUrl(`/watchlist/${response.data.id}`);
            } else {
              this.hasUserCreatedWatchlists = false;
            }
          });
      } else {
        this.watcherService
          .getWatchlistGridData(param.watchlistId)
          .subscribe((response) => {
            this.isGridLoading = false;
            if (response.data && response.data.length) {
              this.setData(response);
            } else {
              this.isWatchlistExist = false;
            }
            this.appService.updateLeftPanelSource.next({
              watchlistId: this.watchlistId,
            });
          });
      }
    });
    this.appService.logUserAction(
      {},
      "",
      "",
      "VA_WATCHLIST",
      { watchlist_Id: this.watchlistId, watchlist_name: this.watchlistName },
      "",
      "WATCHLIST_CLICK",
    );
  }
  /**
   * gets data for LastModalReceived column
   */
  loadLastTransactionInfo() {
    this.watcherService
      .getCompanyLastTransaction(this.watchlistId)
      .subscribe((response) => {
        if (this.watchlistId === Number(response.id)) {
          this.lastTransactionInfo = response.data;
        }
      });
  }

  setData(response) {
    const name = response.name;
    this.isWatchlistExist = true;
    this.hasUserCreatedWatchlists = true;
    this.watchlistGridData = response.data;
    this.watchlistError = "";
    this.inEditMode = false;
    // setting watchlist Id from response because url may or may not have it.
    // its better to set it by reading from response.
    this.watchlistId = Number(response.id);
    this.alertsParams = {
      key: response.id,
      type: "watchlist",
    };
    this.watchlistName = name;
    this.watchlistInitialName = name;
    //wether the wl is created by user or received
    //this boolean is used to disable edit wl name functionality
    this.isOwned = !response.isShared;
    this.loadLastTransactionInfo();
  }

  showWatchlistModal = () => {
    this.isVisibleWatchlistModal = true;
  };

  onCloseWatchlistModal() {
    this.isVisibleWatchlistModal = false;
    this.isVisibleSaveWatchlistModal = false;
  }

  showShareWatchlistModal = () => {
    this.isVisibleShareWLModal = true;
  };

  onCloseShareWatchlistModal = () => {
    this.isVisibleShareWLModal = false;
  };

  showDeleteAlertModal = (): void => {
    const title = `Delete this watchlist?`;

    const message = `Once a watchlist is deleted, you will also lose its <span>Alerts and Sharing<span> settings.`;

    let modal: NzModalRef = null;

    const primaryAction = () => {
      modal.close();
      this.deleteWatchList();
    };

    //configure modal to show alert message
    const modalOptions = {
      title: title,
      body: message,
      accentColor: "#ff4e33",
      icon: faExclamationCircle as IconDefinition,
      actionPrimaryText: "Delete",
      actionSecondaryText: "Cancel",
      onPrimaryClick: primaryAction,
      onSecondaryClick: () => {
        modal.close();
      },
    };

    modal = this.modalService.create(modalOptions);

    modal.afterClose.subscribe(() => {
      this.deleteEntireWatchlist = false;
    });
  };

  showDeleteSuccessModal = (msg: string): void => {
    this.modalService.create({
      title: msg,
      icon: faCheck as IconDefinition,
      accentColor: "#36abad",
    });
  };

  deleteWatchList = (): void => {
    this.updateRemoveBtnLoadingState();
    this.watcherService
      .deleteWatchlistidsForUser({ watcherid: [this.watchlistId] })
      .subscribe(
        (res) => {
          //todo check status from result for errors

          if (res.status === "success") {
            const payload = { ids: [this.watchlistId], key: "watchlist" };
            this.store.dispatch(new DeleteWatchlistData(payload));
            this.updateRemoveBtnLoadingState();
            this.showDeleteSuccessModal("Watchlist is Deleted");
            // redirecting user to /watchlist, so that first watchlist gets selected automatically
            this.router.navigateByUrl("/watchlist");
          }
        },
        (/*err*/) => {
          //console.log(err);
        },
      );
  };

  closeAlertsPopover(visible: boolean) {
    this.visibleAlerts = visible;
  }
  //checks validation of input.
  // called when focus is removed from watchlist rename text box
  onBlurWatchlistName() {
    let validated = true;
    if (this.watchlistName.trim() === "") {
      this.watchlistError = "Watchlist Name cannot be blank.";
      validated = false;
      return validated;
    }

    this.watchlistError = "";
    return validated;
  }

  toggleEditMode = (watchlistRename: HTMLInputElement) => {
    this.inEditMode = !this.inEditMode;
    this.inEditMode ? watchlistRename.focus() : watchlistRename.blur();

    const validated = this.onBlurWatchlistName();

    if (!this.inEditMode && validated) {
      if (this.watchlistName === this.watchlistInitialName) {
        return;
      }

      //watchlist textbox is not in edit mode.
      //call api to save the input as new name for watchlist
      this.watcherService
        .renameWatchlist(this.watchlistId, this.watchlistName)
        .subscribe(
          (response: any) => {
            if (response.status.toLowerCase() === "error") {
              this.watchlistError = response.msg;
              this.inEditMode = true;
            } else {
              const payload = {
                key: "watchlist",
                watchlistId: this.watchlistId,
                label: this.watchlistName,
              };
              this.store.dispatch(new UpdateWatchlistData(payload));
            }
          },

          (/*err*/) => {
            // generic server error message display here
          },
        );
    }
  };

  setEditMode = (watchlistRename: HTMLInputElement) => {
    if (!this.isOwned) {
      //if the watchlist is not created by user.
      //dont allow edit mode
      return;
    }
    this.inEditMode = true;
    watchlistRename.focus();
  };
  //Edit company code start
  openSearchAndAddWatchlistModal() {
    this.tickersList = this.gridData.listOfData.map((gridData) => ({
      ticker: gridData.ticker,
      bTicker: gridData.bbgTicker,
      tickerFullName: gridData.name,
      hasError: false,
      errorMsg: "",
    }));
    this.isVisibleSearchAndAddWatchlistModal = true;
  }

  openAndSaveWatchlistModal() {
    this.tickersList = this.gridData.listOfData.map((gridData) => ({
      ticker: gridData.ticker,
      bTicker: gridData.bbgTicker,
      tickerFullName: gridData.name,
      hasError: false,
      errorMsg: "",
    }));
    this.isVisibleSaveWatchlistModal = true;
  }

  closeSearchAndAddWatchlistModal() {
    this.isVisibleSearchAndAddWatchlistModal = false;
    this.reloadGridData();
  }

  showWarningModal() {
    this.isShowWarningModalVisible = true;
  }

  closeWarningModal() {
    this.isShowWarningModalVisible = false;
  }

  closeAllModals() {
    this.isVisibleSearchAndAddWatchlistModal = false;
    this.isShowWarningModalVisible = false;
    this.resetselectedData();
  }

  resetselectedData() {
    // const onlyTickers = this.updatedTickers.selectedTickers.map(
    //   (ao) => ao.ticker
    // );
    if (this.updatedTickers) {
      this.updatedTickers.currentGridTickers = [];
    }
  }

  updateWatchlistData() {
    const updatedWatchlistObj = {
      watchername: this.watchlistName,
      watcherid: this.watchlistId,
      tickerlist: this.finalizedTickers,
    };

    this.watcherService.updateWatchlist(updatedWatchlistObj).subscribe(
      (success: any) => {
        // success = {}
        if (success) {
          if (this.selectedTickersCount !== 0 && this.loadingState === true) {
            this.showDeleteSuccessModal(
              this.selectedTickersCount === 1
                ? `${this.selectedTickersCount} Company removed.`
                : `${this.selectedTickersCount} Companies are removed.`,
            );
          }
          this.selectedTickersCount = 0;
          // this.gridData.selectedTickers.emit([]);
          this.updateRemoveBtnLoadingState();
          this.closeAllModals();
          this.reloadGridData();
        }
      },
      (err) => {
        console.error(err);
      },
    );
  }

  enableOrDisableUpdateButton(tickers) {
    this.finalizedTickers = tickers;
    this.disableUpdateButton = this.finalizedTickers.length > 0 ? false : true;
  }

  //Edit company code end

  // Remove selected watchlist start

  selectedTickersFromGrid(tickers) {
    this.selectedTickersCount = tickers.size;
    this.selectedGridTickers = [...tickers];
    this.tooltipVisible =
      this.selectedTickersCount === 0 && this.isOwned && this.watchlistId > 0
        ? true
        : false;
  }

  removeSelected() {
    const allTickers = this.gridData.listOfData.map(
      (tickerObj) => tickerObj.ticker,
    );
    this.finalizedTickers = allTickers.filter(
      (x) => this.selectedGridTickers.indexOf(x) < 0,
    );
    // to allow further processing only if any ticker is selected
    if (this.selectedTickersCount > 0 && this.watchlistId > 0 && this.isOwned) {
      if (this.finalizedTickers.length === 0) {
        this.deleteEntireWatchlist = true;
        this.showDeleteAlertModal();
      } else {
        this.loadingState = true;
        this.updateWatchlistData();
      }
    }
  }

  updateRemoveBtnLoadingState() {
    if (this.deleteEntireWatchlist) {
      this.loadingState = true;
      this.deleteEntireWatchlist = false;
    } else if (this.loadingState) {
      this.loadingState = false;
    }
  }

  // Remove selected watchlist end

  //Re-upload Modal code start

  showReuploadModal() {
    this.isVisibleReuploadModal = true;
  }

  closeReuploadModal() {
    this.isVisibleReuploadModal = false;
  }

  reloadGridData() {
    this.isGridLoading = true;
    this.appService.updateLeftPanelSource.next({
      watchlistId: this.watchlistId,
    });
    this.watcherService
      .getWatchlistGridData(this.watchlistId)
      .subscribe((response) => {
        this.setData(response);
        this.isGridLoading = false;
      });
  }
  exportWatchlist() {
    this.isExcelLoading = true;
    const extraParams = {
      watchlistId: this.watchlistId,
      isShared: !this.isOwned,
      iFrameDestructCb: () => (this.isExcelLoading = false),
    };

    this.appService.excelDownload("watchlist_download", extraParams);
  }
}
